// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"75":"not_found","333":"refund","388":"result","779":"error","962":"home"}[chunkId] || chunkId) + "-legacy." + {"75":"96842e45","293":"1dd33e1e","333":"a7ede587","388":"993d9822","395":"f84b8f02","492":"a92dda7d","513":"01e2ce38","779":"b78447bf","936":"936d594d","951":"a8fdac14","962":"11968942"}[chunkId] + ".js";
};